import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { Tab, Tabs } from '@material-ui/core';
import { useUserContext } from '../../contexts/UserContext';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%'
  }
}));


const TabsHeader = (props) => {
  const [currentTab, setCurrentTab] = useState(0);
  const [filteredTabs, setFilteredTabs] = useState([]);

  const { tabs } = props;
  const { isLead, isAdmin } = useUserContext();
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();

  useEffect(() => {
    // Filter the tabs based on the user type
    let filterTabs = tabs.filter((tab) => (
      isTabDisplayed(tab)
    ));
    setFilteredTabs(filterTabs);
    
  }, [isLead, isAdmin])

  useEffect(() => {
    // When the Header component mounts, check for the current path and indicate the
    // active tab properly (i.e select indicator line under the tab name)
    let currentPath = location.pathname;

    filteredTabs.find((tab, index) => {
      if (currentPath === tab.path) {
        setCurrentTab(index);
      }
      return null;
    });
    
  }, [filteredTabs])

  const handleChange = (event, changedTab) => {
    setCurrentTab(changedTab);

    filteredTabs.find((tab, index) => {
      if (index === changedTab) {
        history.push(tab.path);
      }
      return null;
    });
  }

  const isTabDisplayed = (tab) => {
    if (tab.onlyAdmin && isAdmin)
      return true;
    else if (tab.onlyLead && isLead)
      return true;
    else if (!tab.onlyAdmin && !tab.onlyLead)
      return true;
    else
      return false;
  }


  return (
    <div className={classes.root}>
      <Tabs value={currentTab} onChange={handleChange}>
        {/*
  Following condition will check for cases where only admin content needs to be rendered
  Section 1: if 'only admin' content is passed, will only be true when user 'is admin'
  Section 2: if any user content (NOT 'only admin') is passed, will be true for any user
  Content will be only returned if Section1 OR Section 2 is true
  
  Indexes are passed in to help React keep track of array elements that are rendered.
  N.B Indexes are auto-generated by React in this case.
  */}
        {
          filteredTabs.map((tab, index) => (
            <Tab key={index} label={tab.label} icon={tab.icon} />
          ))
        }
      </Tabs>
    </div>
  );
}

export default TabsHeader;
